import InsertTable from './InsertTable'

export const insertTableMenuConf = {
  key: 'insertNTable',
  factory() {
    return new InsertTable()
  },
}
